/**
 * Gemini AI Service - Explicitly using gemini-2.5-flash as requested
 */

const generateGemini = async (prompt, retries = 3) => {
  const apiKey = process.env.REACT_APP_GEMINI_API_KEY;

  if (!apiKey) {
    throw new Error("Gemini API Key is missing. Please add REACT_APP_GEMINI_API_KEY to your .env file.");
  }

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${apiKey}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                {
                  text: prompt
                }
              ]
            }
          ],
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 503 && attempt < retries) {
          console.warn(`Google Servers are busy (503). Retrying in ${attempt * 2} seconds... (Attempt ${attempt}/${retries})`);
          await new Promise(resolve => setTimeout(resolve, attempt * 2000));
          continue; // Try again
        }

        console.error("Gemini API Error:", data);
        throw new Error(data.error?.message || "Gemini generation failed.");
      }

      // Extract text from Gemini response structure
      return data.candidates[0].content.parts[0].text;

    } catch (error) {
      if (attempt === retries) {
        console.error("Gemini Network Error:", error);
        throw new Error(error.message || "Failed to connect to Gemini AI after multiple attempts.");
      }
      console.warn(`Network glitch. Retrying... (Attempt ${attempt}/${retries})`);
      await new Promise(resolve => setTimeout(resolve, attempt * 2000));
    }
  }
};

/**
 * Generates a hotel overview
 */
export const generateText = async (hotelName, location, packagePrice) => {
  const prompt = `Write an engaging and professional hotel overview for a travel website.
    Hotel Name: "${hotelName}"
    Location: ${location}
    Starting Package Price: ₹${packagePrice}
    The overview should be approximately 400 words.`;

  return await generateGemini(prompt);
};

/**
 * Generates a short description
 */
export const generateDescription = async (hotelName, location) => {
  const prompt = `Write a short, catchy 20-word summary for "${hotelName}" located in ${location}.`;
  return await generateGemini(prompt);
};

// Compatibility aliases
export const generateOverview = generateText;
export const generatePackageDescription = async (packageName, location, nights, days, packagePrice) => {
  const prompt = `Write a short, engaging description (around 30-50 words) for a travel package named "${packageName}" in ${location} for ${nights} nights and ${days} days, priced at ₹${packagePrice}. Do NOT use any markdown formatting (like ** for bold). Provide only plain text.`;
  return await generateGemini(prompt);
};
export const generatePackageOverview = async (packageName, location, nights, days, packagePrice) => {
  const prompt = `Write a comprehensive and engaging travel itinerary overview for "${packageName}" in ${location} for ${nights} nights and ${days} days, priced at ₹${packagePrice}. Provide the response in clean HTML format suitable for a rich text editor. Use standard HTML tags like <h3>, <p>, <ul>, <li>, and <strong>. Do NOT wrap the response in markdown code blocks.`;
  return await generateGemini(prompt);
};